import * as appActionTypes from "../../actions/AppState/type";
import { UPDATE_THREAD_HEADING } from "../../actions/ArkchatGroup/type";

const initState = {
  currentHomeIndexTab:0,
  isThreadScreen: false,
  isThreadListOpen: false,
  threadToOpenData: null,
  shouldCallPubnubGetToken: false,
  isLoading: false,
  isAccountSwitchLoading: false,
  openRouteDeleteAccountDetail:{},
  // Bumped when a group's threads change (new message/reply, rename) so the
  // Threads panel, which keeps its own list, can update it.
  threadListChange: null,
  // Bumped when a group's files change (e.g. renamed) so an open Files
  // section re-reads them.
  attachmentsChange: null,
  // Bumped when a task/approval is created or updated, so an open Track Work
  // view re-runs its query.
  workTrackingChange: null,
};

export const localAppReducer = (state = initState, action) => {
  switch (action.type) {
    case appActionTypes.SET_HOMETAB_VALUE:
      return {
        ...state,
        currentHomeIndexTab: action?.payload,
      };
    case appActionTypes.OPEN_CLOSE_THREAD_VIEW:
      return {
        ...state,
        isThreadScreen: action?.payload,
      };
    case appActionTypes.THREAD_LIST_PANEL_OPEN:
      return {
        ...state,
        isThreadListOpen: action?.payload,
      };
    case appActionTypes.THREAD_TO_OPEN_FROM_LIST:
      return {
        ...state,
        threadToOpenData: action?.payload,
      };
    case appActionTypes.SHOULD_CALL_PUBNUB_GET_TOKEN:
      return {
        ...state,
        shouldCallPubnubGetToken: action?.payload,
      };
    case appActionTypes.IS_LOADING:
      return {
        ...state,
        isLoading: action?.payload,
      };
    case appActionTypes.ACCOUNT_SWITCH_LOADING:
      return {
        ...state,
        isAccountSwitchLoading: action?.payload,
      };
    case appActionTypes.THREAD_LIST_CHANGED:
      return {
        ...state,
        threadListChange: {
          seq: (state.threadListChange?.seq || 0) + 1,
          pnId: action?.payload?.pnId,
          deletedTempTimetoken: action?.payload?.deletedTempTimetoken,
          moved: action?.payload?.moved,
        },
      };
    case appActionTypes.WORK_TRACKING_CHANGED:
      return {
        ...state,
        workTrackingChange: {
          seq: (state.workTrackingChange?.seq || 0) + 1,
          pnId: action?.payload?.pnId,
        },
      };
    case appActionTypes.ATTACHMENTS_CHANGED:
      return {
        ...state,
        attachmentsChange: {
          seq: (state.attachmentsChange?.seq || 0) + 1,
          pnId: action?.payload?.pnId,
        },
      };
    case UPDATE_THREAD_HEADING:
      return {
        ...state,
        threadListChange: {
          seq: (state.threadListChange?.seq || 0) + 1,
          renamed: action?.payload,
        },
      };
      case appActionTypes.DELETE_ACCOUNT_API_RESPONSE_DATA:
        return {
          ...state,
          openRouteDeleteAccountDetail: action?.payload,
        };
    default:
      return state;
  }
};
